import axios from 'axios'
import { AccountStatus } from '../types'
import { TRADING_RESTRICTIONS_API, WITH_CREDENTIALS_CONFIG } from './constants'

export const getTradingRestrictions = (accountNumber: string) =>
  axios.get(
    `${TRADING_RESTRICTIONS_API}${accountNumber}`,
    WITH_CREDENTIALS_CONFIG
  )

export const restrictAccount = (
  accountNumber: string,
  accountStatus: AccountStatus,
  reason: string
) =>
  axios.post(
    `${TRADING_RESTRICTIONS_API}${accountNumber}`,
    { accountStatus, reason },
    WITH_CREDENTIALS_CONFIG
  )
